import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Group = types.compose(
  'Group',
  BaseEntity,
  types.model({
    groupId: types.identifierNumber,
    name: types.string,
    description: types.string,
    color: types.string,
    targetDutyCount: types.number,
    targetDayDutyCount: types.number,
    targetNightDutyCount: types.number,
    secretariatId: types.maybe(types.integer),
  }),
);
